export const person = [
{id: '1', name: 'الاستاذ/باتمان', date: '5 PM', img: '/img/batman_hero_avatar_comics-512.ico' },
{ id: '2', name: 'مني', date: '7 PM', img: '/img/beautiful-latin-woman-avatar-character-icon-free-vector.ico' },
{ id: '3', name: 'حسن', date: '9 PM', img: '/img/ilustracion-avatar-hombre-negocios-retrato-usuario-dibujos-animados-icono-perfil-usuario_118339-4397_1.ico' },
{ id: '4', name: 'عماد', date: '11 PM', img: '/img/image_processing20220801-17461-1o2jsxj.ico' },
{ id: '5', name: 'الواد بلية', date: '9 AM', img: '/img/ee42d400-ac11-11ea-95fd-641da59b458b_1.ico' },
{ id: '6', name: 'الاستاذ/باتمان', date: '5 PM', img: '/img/4570194.ico' },
{ id: '7', name: 'الاستاذ/باتمان', date: '5 PM', img: '/img/4570194.ico' },
{ id: '8', name: 'الاستاذ/باتمان', date: '5 PM', img: '/img/4570194.ico' },
{ id: '9', name: 'الاستاذ/باتمان', date: '5 PM', img: '/img/4570194.ico' },
]